import gql from 'graphql-tag';

import { USER_FRAGMENT } from '../../../common/graphql/user';

export const GET_MOBILE_USER = gql`
	query getMobileUser($id: String) {
		getUser(id: $id) {
			...user
			clientsLeadAccess {
				canView
				canManage
			}
		}
	}
	${USER_FRAGMENT}
`;

// Managers who can sign off a vehicle check: same server search as the old
// user selector (filter.query), one page at a time.
export const GET_SIGN_OFF_MANAGERS = gql`
	query($page: Int!, $perPage: Int!, $filter: UserPageFilter) {
		getUsers(page: $page, perPage: $perPage, sortBy: "firstname", sortDirection: 1, filter: $filter) {
			items {
				id
				firstname
				lastname
				username
			}
			count
		}
	}
`;
